export const profile = {
  name: '전성진',
  role: 'Java/Spring Backend Developer',
  experience: '백엔드·웹 개발 실무 3년+',
  headline: '금융 서비스 운영 경험을 가진 Java/Spring 백엔드 개발자 전성진입니다.',
  introduction:
    '대규모 메시징 환경에서 서비스 흐름을 분석하고, 장애 원인을 추적하며, 안정적인 운영을 위한 개선을 이어왔습니다.',
};

export const navigation = [
  { label: '소개', href: '#about' },
  { label: '경력', href: '#career' },
  { label: '주요 업무', href: '#work' },
  { label: '프로젝트', href: '#projects' },
  { label: '기술', href: '#skills' },
  { label: '연락', href: '#contact' },
];

export const summaryPoints = [
  {
    id: 'financial-messaging',
    title: '금융 UMS/GMS',
    description: 'Java/Spring 기반 금융 메시징 웹 서비스 개발과 운영 대응',
  },
  {
    id: 'message-flow',
    title: '메시징 엔진·Queue 분석',
    description: '로그, DB, 큐 상태와 코드 흐름을 연결해 장애 원인을 추적',
  },
  {
    id: 'service-stability',
    title: '운영 안정성 개선',
    description: '대량 발송 환경의 병목 구간을 찾아 처리 지연과 운영 위험을 완화',
  },
];

export const career = [
  {
    id: 'eodain',
    company: '어다인주식회사',
    role: '개발실 주임/계장',
    period: '2025.09 — 현재',
    summary: '금융권 고객사 대상 UMS/GMS 웹 시스템 운영, 유지보수 및 기능 개선',
    highlights: [
      '2026.05.18부터 신한DS 금융권 프로젝트에 파견되어 신한은행 업무 환경에서 UMS/GMS 시스템 운영 및 장애 대응',
      '광주은행 UMS 웹 서비스와 하나증권 UMS 웹 서비스 개발 및 유지보수',
      '메시지 발송, 결과 처리, 전환 발송, 정산·통계, 모니터링 흐름 분석 및 개선',
      '로그, DB 데이터, 큐 상태와 코드 흐름을 근거로 운영 이슈 원인 분석 및 조치',
    ],
  },
  {
    id: 'people-and-forest',
    company: '(주)미디어그룹사람과숲',
    role: 'BIG AI 사업 팀원',
    period: '2022.11 — 2025.03',
    summary: 'Java/Spring과 React를 활용한 공공 분야 웹 서비스 개발',
    highlights: [
      '표준연계화면, 정보공개포털 등 공공 시스템 개발 및 UI/UX 개선',
      'Oracle 데이터 마이그레이션과 레거시 API 개선 및 성능 최적화',
      '빅데이터 기반 교통 통계 시스템과 무장애 관광 서비스 개발',
      '백엔드 설계부터 프론트엔드 구현까지 프로젝트 단위로 수행',
    ],
  },
];

export const earlierCareer = [
  {
    id: 'smc',
    company: '에스엠씨엔지니어링(주)',
    period: '2021.07 — 2022.04',
    description: 'SK하이닉스 반도체 세정 장비 점검 및 유지보수',
  },
  {
    id: 'hyundai',
    company: '현대자동차(주)',
    period: '2018.12 — 2020.08',
    description: '완성차 조립 공정 생산 업무',
  },
  {
    id: 'taehyung',
    company: '태형산업',
    period: '2018.10 — 2018.12',
    description: '산업용 변압기 부품 조립 및 품질 관리',
  },
];

export const selectedWork = [
  {
    id: 'financial-ums-gms',
    number: '01',
    title: '금융 UMS/GMS 운영 및 개선',
    context: '어다인주식회사 · 금융권 프로젝트',
    description:
      '금융 메시징 서비스의 웹 화면부터 메시징 엔진과 외부 채널 연동까지 전체 흐름을 분석하고 운영 이슈에 대응했습니다.',
    details: [
      '카카오 알림톡·친구톡 등 외부 메시징 채널 API 연동과 규격 변경 대응',
      'Java 기반 자사 메시징 엔진과 Memory Queue 구조 분석',
      '월 1.5억 건 이상의 메시지를 처리하는 환경에서 발송 상태와 장애 징후 모니터링',
      '특정 고객사 대량 발송 시 최대 10분 이상 발생하던 처리 지연을 2~3분 수준으로 완화하는 개선 작업 참여',
      'Java와 React 기반 선거 문자 발송 사이트 개발 및 운영',
    ],
    technologies: ['Java', 'Spring Boot', 'Vue', 'React', 'Oracle', 'Memory Queue', 'REST API', 'FreeMarker'],
  },
  {
    id: 'korail-interface',
    number: '02',
    title: '한국철도공사 표준연계화면 개발',
    context: '(주)미디어그룹사람과숲 · 공공 시스템 프로젝트',
    description: '표준 연계를 위한 사용자·관리자 기능과 백엔드 API를 개발했습니다.',
    details: [
      'React와 Spring Boot 기반 사용자·관리자 기능 구현',
      '연계 업무에 필요한 REST API 설계 및 개발',
      '기존 시스템 구조에 맞춘 화면·데이터 흐름 개선',
    ],
    technologies: ['Java', 'Spring Boot', 'React', 'REST API'],
  },
  {
    id: 'assembly-open-data',
    number: '03',
    title: '국회 정보공개포털 개발',
    context: '(주)미디어그룹사람과숲 · 공공 시스템 프로젝트',
    description: '레거시 API와 데이터 구조를 정비하고 조회 흐름의 성능을 개선했습니다.',
    details: [
      '레거시 API 개선과 데이터 마이그레이션 수행',
      'Oracle 기반 데이터 검증과 조회 쿼리 개선',
      'API와 데이터 처리 흐름 분석을 통한 성능 개선',
    ],
    technologies: ['Java', 'Spring Framework', 'Oracle', 'REST API'],
  },
  {
    id: 'traffic-statistics',
    number: '04',
    title: '빅데이터 교통 통계 시스템',
    context: '(주)미디어그룹사람과숲 · 데이터 플랫폼 프로젝트',
    description: '대량 교통 데이터를 조회하고 시각화하는 서비스의 백엔드 로직을 구현했습니다.',
    details: [
      '교통·날씨·돌발상황 데이터를 활용한 통계 서비스 개발',
      '대시보드와 지도 데이터 제공을 위한 API 구현',
      'PostgreSQL 데이터 모델과 조회 쿼리 작성',
    ],
    technologies: ['Java', 'Spring Framework', 'PostgreSQL', 'REST API'],
  },
  {
    id: 'accessible-docent',
    number: '05',
    title: '무장애 관광 도슨트 앱',
    context: '(주)미디어그룹사람과숲 · 관광 서비스 프로젝트',
    description: '관광취약계층을 위한 관광 정보 서비스의 백엔드 기능과 데이터 구조를 개발했습니다.',
    details: [
      '전자정부표준프레임워크와 Spring 기반 API 개발',
      'PostgreSQL 데이터 설계와 조회 쿼리 작성',
      '관광지 간 경로 탐색 로직과 서비스 데이터 연동',
    ],
    technologies: ['Java', '전자정부표준프레임워크', 'Spring', 'PostgreSQL'],
  },
];

export const projects = {
  featured: {
    id: 'topago',
    title: '토파고',
    context: '개인 운영 서비스 · Private repository',
    description:
      '공식 경기 데이터를 수집·정규화하여 모델 확률, 데이터 신뢰도, 분석 근거와 사후 검증 결과를 제공하는 스포츠 데이터 분석 서비스입니다.',
    details: [
      '공개 경기 데이터 수집부터 분석, 결과 정산까지 이어지는 배치 파이프라인 구현',
      '분석 결과와 데이터 신뢰도, 검증 성과를 확인할 수 있는 공개 대시보드 운영',
      '실제 구매·중개 기능 없이 분석 정보를 제공하며 핵심 분석 로직과 데이터 구조는 비공개로 관리',
    ],
    technologies: ['Next.js', 'TypeScript', 'PostgreSQL', 'Drizzle ORM', 'Vitest'],
    href: 'https://topago.co.kr',
  },
  team: [
    {
      id: 'peony-factory',
      title: 'PeonyFactory',
      period: '2022.08.29 — 2022.09.08',
      description: '공정별 오류와 생산 데이터를 관리·시각화하는 제조 공정 모니터링 시스템',
      technologies: ['Java', 'Spring MVC', 'MyBatis', 'Oracle', 'ECharts'],
      href: 'https://github.com/jinygod/PeonyFactory',
    },
    {
      id: 'peony-shop',
      title: 'PeonyShop',
      period: '2022.08.13 — 2022.08.28',
      description: '회원, 상품, 장바구니와 게시판 기능을 구현한 여성 의류 쇼핑몰 팀 프로젝트',
      technologies: ['Java', 'Spring MVC', 'MyBatis', 'Oracle', 'JavaScript'],
      href: 'https://github.com/jinygod/peonyshop',
    },
  ],
  outside: [
    {
      id: 'joseon-hunter',
      title: 'JoseonHunter',
      description: '조선 민속 판타지 모바일 생존 로그라이트의 Unity 마이그레이션 프로젝트',
      href: 'https://github.com/jinygod/JoseonHunter',
    },
    {
      id: 'joseon-survival',
      title: 'Joseon-Dynasty-Survival',
      description: '조선 민속 판타지를 소재로 한 개인 게임 프로젝트',
      href: 'https://github.com/jinygod/Joseon-Dynasty-Survival',
    },
    {
      id: 'roguelike-game',
      title: 'roguelike-game',
      description: '반응형 픽셀 전투를 구현한 턴제 전술 로그라이크 웹 프로토타입',
      href: 'https://github.com/jinygod/roguelike-game',
    },
  ],
};

export const skillGroups = [
  {
    id: 'production',
    title: '실무 경험',
    items: [
      'Java',
      'Spring Framework',
      'Spring Boot',
      'MyBatis',
      'REST API',
      'Oracle',
      'PostgreSQL',
      'MariaDB / MySQL',
      'React',
      'Vue',
      'JavaScript',
      'UMS / GMS',
      'Memory Queue',
      'Git',
    ],
  },
  {
    id: 'additional',
    title: '추가 경험',
    items: ['Python', 'TypeScript', 'HTML5', 'CSS', 'Unity', 'C#'],
  },
];

export const credentials = [
  { id: 'sql-developer', title: 'SQL 개발자', date: '2025.08' },
  { id: 'industrial-engineer', title: '정보처리산업기사', date: '2025.08' },
  { id: 'network-manager', title: '네트워크관리사 2급', date: '2025.06' },
];

export const education = [
  { id: 'computer-science', title: '컴퓨터공학 학사 과정 이수 중' },
  { id: 'ezen', title: '이젠컴퓨터아카데미 빅데이터 개발자 양성과정' },
  { id: 'munhyeon', title: '문현고등학교 졸업', date: '2012' },
];

export const contact = {
  email: 'ayclub8866@naver.com',
  github: 'https://github.com/jinygod',
};
